/*
 * jQuery Application (legacy)
 */
import jQueryApplication from '../jQueryApplication/common';

/*
 * Web application storage
 */
import store from './Storage';

/**
 * Components
 */
// Modals
const theModal = () => import('./Components/Modal/TheModal.vue');
const renderModal = () => import('./Components/Modal/RenderModal.vue');
const closeModal = () => import('./Components/Modal/CloseModal.vue');
const AppTooltip = () => import('./Components/AppTooltip.vue');

// Misc
const rsForm = () => import('./Components/AsyncData/Renderers/RSFormRenderer.vue');


/**
 * Main application instance
 */
export default {
  // store,

  components: {
    // Modal
    // theModal,
    // renderModal,
    // closeModal,
    //
    // // Misc
    // rsForm,
      AppTooltip
  },

  /**
   * Boot
   */
  mounted() {
    jQueryApplication(this.$el);
  },

};



// WEBPACK FOOTER //
// ./templates/floor/assets/js/VueApplication/App.js